import * as z from "zod";

export const duplicateAutomationWithOptions = {
  name: "duplicateAutomationWithOptions" as const,
  input: z.object({
    automationId: z.string(),
    name: z.string().min(1),
    targetTriggerKey: z.string(),
    targetTeamIds: z.array(z.string()).optional(),
  }),
  output: z.object({
    results: z.array(
      z.object({ teamId: z.string(), automationId: z.string() }),
    ),
  }),
};
